jQuery(document).ready(function ($) {
  function adjustWrapperHeight() {
    const announcement = document.querySelector(".announcement-bar-holder");
    const header = document.querySelector("header");
    const stickyHeader = document.getElementById("shopify-section-header");

    const headerHeight = header?.offsetHeight || 0;

    // If sticky header is showing or announcement doesn't exist, we ignore it
    const isSticky =
      stickyHeader?.classList.contains("shopify-section-header-sticky") &&
      stickyHeader?.classList.contains("animate");

    let announcementHeight = 0;

    if (!isSticky && announcement) {
      const rect = announcement.getBoundingClientRect();
      // Only count the part of the announcement visible on screen
      announcementHeight = Math.max(0, Math.min(rect.height, rect.bottom));
    }

    const totalOffset = headerHeight + announcementHeight - 1;

    const mobileMenu = document.getElementById("mobile-menu");
    const wrapper = document.querySelector(".menu-wrapper");

    if (mobileMenu) {
      mobileMenu.style.top = `${totalOffset}px`;
      mobileMenu.style.height = `${window.innerHeight - totalOffset}px`;
    }

    if (wrapper) {
      wrapper.style.height = "100%";
    }
  }

  //  Expose globally for use in MobileScreenMenu
  window.adjustWrapperHeight = adjustWrapperHeight;

  window.addEventListener("load", adjustWrapperHeight);
  window.addEventListener("resize", adjustWrapperHeight);

  function changeMenu($currentLevel, $targetLevel) {
    $currentLevel.removeClass("active");
    $targetLevel.addClass("active");

    //  Force reflow to allow smooth transition
    $targetLevel[0].offsetHeight;

    //  Ensure scroll position resets after transition
    $targetLevel.one("transitionend", function (e) {
      if (e.originalEvent.propertyName === "transform") {
        scrollMenuWrapperToTop();
      }
    });

    //  Fallback scroll reset (if transitionend doesn't fire)
    setTimeout(scrollMenuWrapperToTop, 400);
  }

  function scrollMenuWrapperToTop() {
    const wrapper = document.querySelector(".menu-wrapper");
    if (!wrapper) return;

    // Optional: only reset scroll if body is locked (for iOS + scroll-lock libraries)
    if (!document.body.classList.contains("overflow-lock")) return;

    wrapper.scrollTop = 0;
  }

  //  Menu drill-down handling
  $("#mobile-menu").on("click", ".has-children", function () {
    const target = $(this).data("target");
    const $currentLevel = $(this).closest(".menu-level");
    const $targetLevel = $(target);
    changeMenu($currentLevel, $targetLevel);
  });

  $("#mobile-menu").on("click", ".back-btn", function () {
    const target = $(this).data("target");
    const $currentLevel = $(this).closest(".menu-level");
    const $targetLevel = $(target);
    changeMenu($currentLevel, $targetLevel);
  });
});
